// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lFR41","delete":"styles_delete__1xgbP","update":"styles_update__XZBZF","add":"styles_add__-NIfu"};